import { BaseModel } from "model/BaseModel";

export default class Endereco implements BaseModel {
    id: number;
    codigo = "";
    logradouro: string;
    cep: string;
    numero: number;
    estado: string;
    cidade: string;
    bairro: string;
    complemento: string;
    observacao: string;
    latitude: number;
    longitude: number;

    constructor(
        id: number = 0,
        logradouro: string = "",
        cep: string = "",
        numero: number = 0,
        estado: string = "",
        cidade: string = "",
        bairro: string = "",
        complemento: string = "",
        observacao: string = "",
        latitude: number = 0,
        longitude: number = 0
    ) {
        this.id = id;
        this.logradouro = logradouro;
        this.cep = cep;
        this.numero = numero;
        this.estado = estado;
        this.cidade = cidade;
        this.bairro = bairro;
        this.complemento = complemento;
        this.observacao = observacao;
        this.latitude = latitude;
        this.longitude = longitude;
    }
}